<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>
          <h5>Fornecedor: {{nomefor}}</h5>
        </v-toolbar-title>
        <v-tabs
          v-model="active"
          show-arrows
          slot="extension"
          color="grey lighten-4"
          slider-color="black"
        >
          <v-tab key="1" ripple>Baixa de Requisições</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:180px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO NOME DO DEPENDENTE -->
                  <v-flex xs12 sm2>
                    <v-text-field v-model="requisicao.id" label="Código" v-bind:readonly='true'></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field v-model="requisicao.data_lancto" label="Data" v-bind:readonly='true'></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field v-model="requisicao.profissional" label="Profissional" v-bind:readonly='true'></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field v-model="requisicao.veiculo" label="Veículo" v-bind:readonly='true'></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="requisicao.plano" label="Descrição" v-bind:readonly='true'></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="odometro_edit === true">
                    <v-text-field
                      v-model="requisicao.odometro"
                      label="Odômetro"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="odometro_edit === false">
                    <v-text-field
                      v-model="requisicao.odometro"
                      label="Odômetro"
                      v-bind:readonly='true'
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 v-if="litros_edit === true">
                    <v-currency-field
                      v-model="requisicao.litros"
                      label="Litros"
                      v-bind="currency_litro"
                      @input="onValorSelect()"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm4 v-if="litros_edit === false">
                    <v-currency-field
                      v-model="requisicao.litros"
                      label="Litros"
                      v-bind="currency_litro"
                      v-bind:readonly='true'
                      @input="onValorSelect()"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm4 v-if="preco_litro_edit === true">
                    <v-currency-field
                      v-model="requisicao.preco_litro"
                      v-bind="currency_litro"
                      label="Preço litro"
                      @input="onValorSelect()"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm4 v-if="preco_litro_edit === false">
                    <v-currency-field
                      v-model="requisicao.preco_litro"
                      v-bind="currency_litro"
                      label="Preço litro"
                      v-bind:readonly='true'
                      @input="onValorSelect()"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm4 v-if="valor_total_edit === true">
                    <v-currency-field
                      v-model="requisicao.valor_total"
                      label="Valor total"
                      @input="onValorSelect()"
                      ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm4 v-if="valor_total_edit === false">
                    <v-currency-field
                      v-model="requisicao.valor_total"
                      label="Valor total"
                      v-bind:readonly='true'
                      @input="onValorSelect()"
                      ></v-currency-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
        </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/requisicoesbaixa')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="onZerar()" :loading="loading">Zerar valores</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="onLanctoSaveClick()" :loading="loading">Baixar</v-btn>
      </v-card-actions>
    </v-card>
    <div style="margin:50px"></div>
  </span>
</template>
<script>
import { showConfirm, showError } from '@/utils'
import requisicaoService from '@/services/requisicao'

export default {
  name: 'viagens',
  data () {
    return {
      odometro_edit: false,
      litros_edit: false,
      preco_litro_edit: false,
      valor_total_edit: false,
      requisicao: {},
      nomefor: '',
      loading: false,
      valid: true,
      active: 0,
      currency_litro: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: ' ',
        precision: 4,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      }
    }
  },
  mounted: async function () {
    try {
      let id = this.$route.params.id
      const result = await requisicaoService.getByGetBaixa(id)
      if (result.data[0] !== undefined) {
        this.requisicao = result.data[0]
        this.nomefor = result.data[0].fornecedor
        this.requisicao.fk_empresa = result.data[0].fk_empresa
        if (result.data[0].odometro === '0') {
          this.odometro_edit = true
        }
        if (result.data[0].litros === '0.0000') {
          this.litros_edit = true
        }
        if (result.data[0].preco_litro === '0.0000') {
          this.preco_litro_edit = true
        }
        if (result.data[0].valor_total === '0.00') {
          this.valor_total_edit = true
        }
      } else {
        showError('Lançamento não localizado!!!')
      }
    } catch (error) {
      showError(error)
    } finally {
    }
  },
  methods: {
    async onValorSelect () {
      if (this.requisicao.litros > 0 && this.requisicao.preco_litro > 0) {
        this.requisicao.valor_total = this.requisicao.preco_litro * this.requisicao.litros
      } else if (this.requisicao.preco_litro > 0 && this.requisicao.valor_total > 0) {
        this.requisicao.litros = this.requisicao.valor_total / this.requisicao.preco_litro
      } else if (this.requisicao.litros > 0 && this.requisicao.valor_total > 0) {
        this.requisicao.preco_litro = this.requisicao.valor_total / this.requisicao.litros
      }
    },
    async onZerar () {
      if (this.litros_edit === true) {
        this.requisicao.litros = 0
      }
      if (this.preco_litro_edit === true) {
        this.requisicao.preco_litro = 0
      }
      if (this.valor_total_edit === true) {
        this.requisicao.valor_total = 0
      }
    },
    async onLanctoSaveClick () {
      if (this.requisicao.litros === '0.0000') {
        showError('Litros inválido')
        return
      }
      if (this.requisicao.preco_litro === '0.0000') {
        showError('Preço litro inválido')
        return
      }
      if (this.requisicao.valor_total === '0.00') {
        showError('Valor total inválido')
        return
      }
      try {
        showConfirm(`Confirma baixa de requisição ?`, async result => {
          if (result) {
            try {
              await requisicaoService.saveAltera(this.requisicao)
              this.$router.push(`/requisicoesbaixa`)
            } catch (error) {
              showError(error)
            } finally {
            }
          }
        })
      } catch (error) {
        showError(error)
      }
    }
  }
}
</script>
<style scope>
.flex{
    height: 60px;
  }
.e-data-table3 {
  background: red;
}
</style>
